import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "1b0626b9-6e28-4331-8afe-aeed2fc15a5d", content: "A shaker", options: {} },
  { id: "1358012d-a79a-4d27-8561-0d48b80ae93f", content: "A subwoofer", options: {} },
  { id: "bc15f2b7-b9b1-4900-8295-c1776096ab25", content: "A vertical line array", options: {} },
  { id: "016b3311-233b-425d-bde5-61f4f07b50ca", content: "A vented-box enclosure", options: {} },
  {
    id: "dc828536-e8ba-4f17-926c-72483ed7e106",
    content: "A speaker array whose inputs<br>have been calulated using the<br>pressure matching approach",
    options: {},
  },
  { id: "20112d4a-434c-4d82-b9b1-8d0de85a8c9a", content: "A parameteric antenna", options: {} },
];

export const task: Task = {
  id: "f84a7e7b-0bed-42ce-b9f1-c42ab09b4a4a",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 1,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["dc828536-e8ba-4f17-926c-72483ed7e106", "20112d4a-434c-4d82-b9b1-8d0de85a8c9a"],
};
